import { render } from "./Guest.vue?vue&type=template&id=5421e404"
import script from "./Guest.vue?vue&type=script&setup=true&lang=js"
export * from "./Guest.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/Guest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5421e404"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5421e404', __exports__)) {
    api.reload('5421e404', __exports__)
  }
  
  module.hot.accept("./Guest.vue?vue&type=template&id=5421e404", () => {
    api.rerender('5421e404', render)
  })

}


export default __exports__